// src/components/formBuilder/AIBuilderModal.jsx
import React from 'react';
import axios from 'axios';
import { auth } from '../../firebase-config';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
} from '@mui/material';
import ButtonComponent from '../ui/ButtonComponent';
import { useToast } from '../ui/ToastContext';

// Placeholder for your new Cloud Function URL
const GENERATE_URL =
  process.env.REACT_APP_GENERATE_FORM_URL ||
  'https://generateform-774073159618.us-central1.run.app';

export default function AIBuilderModal({ open, onClose, onComplete }) {
  const { addToast } = useToast();
  const [prompt, setPrompt] = React.useState('');
  const [isGenerating, setIsGenerating] = React.useState(false);

  const handleGenerate = async () => {
    if (!prompt.trim()) {
      addToast('Please enter a description.', 'warning');
      return;
    }
    setIsGenerating(true);
    try {
      const idToken = await auth.currentUser.getIdToken(true);
      const { data } = await axios.post(
        GENERATE_URL,
        { prompt },
        { headers: { Authorization: `Bearer ${idToken}` } }
      );

      if (data.schema) {
        addToast('Kinova generated the form successfully!', 'success');
        onComplete(data.schema); // Pass the schema back to the builder
        onClose(); // Close the modal
        setPrompt(''); // Reset prompt for next time
      } else {
        throw new Error('Kinova response did not contain a valid schema.');
      }
    } catch (err) {
      console.error('Failed to generate form from Kinova:', err);
      addToast(err.message || 'An error occurred while generating the form.', 'error');
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>✨ Let Kinova Build It!</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }} color="text.secondary">
          Describe the form you want to build. Be as specific as possible. For example, "Create a job application with fields for name, email, phone, resume upload, and a cover letter."
        </Typography>
        <TextField
          autoFocus
          margin="dense"
          id="ai-prompt"
          label="Form Description"
          type="text"
          fullWidth
          multiline
          rows={5}
          value={prompt}
          onChange={(e) => setPrompt(e.target.value)}
          placeholder="e.g., A contact form with first name, last name, and a message..."
        />
      </DialogContent>
      <DialogActions sx={{ p: 3, pt: 1 }}>
        <ButtonComponent label="Cancel" onClick={onClose} type="secondary" disabled={isGenerating} />
        <ButtonComponent
          label="Generate Form"
          onClick={handleGenerate}
          isLoading={isGenerating}
          type="primary"
        />
      </DialogActions>
    </Dialog>
  );
}